import { useHistory } from "react-router-dom";
import { post,get } from 'helpers/api_helper';

export function useLogout() {
  const history = useHistory(); // Use history for navigation

  const logout = async () => {
    try {
    
        //clean local storage
        localStorage.removeItem('authUser');
        localStorage.removeItem('token');
        localStorage.removeItem('active_parenting_space_id');
        localStorage.removeItem('active_parenting_space');
        history.push("/login"); 
    
    } catch (error) {
       return
    }
  };

  return { logout };
}